var validPhoneStrict = function validPhoneStrict(_a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.message,
    message = _c === void 0 ? 'Введите корректный номер телефона' : _c,
    _d = _b.emptyMessage,
    emptyMessage = _d === void 0 ? 'Обязательное поле' : _d,
    _e = _b.required,
    required = _e === void 0 ? true : _e;
  return function (value) {
    var _a;
    var re = /^7\d{10}$/;
    if (!((_a = value === null || value === void 0 ? void 0 : value.trim()) === null || _a === void 0 ? void 0 : _a.replace(/^7/, ''))) {
      return required ? emptyMessage : undefined;
    }
    return re.test(value) ? undefined : message;
  };
};
export { validPhoneStrict };